// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
  factory('report', ['$http', '$q', 'obexConstant', 'authService',
    ($http, $q, obexConstant, authService) => {
      return {
        getAirActivity(startDate, endDate, organizationId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlFlights}/admin/${startDate}/${endDate}/${organizationId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getProfiles(organizationId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlProfiles}/organization/${organizationId}`;
            return $http.get(url, {
              headers: authHeader
            });
          });
        },        
        getHotelActivity(startDate, endDate, organizationId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlHotels}/admin/${startDate}/${endDate}/${organizationId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getCarActivity(startDate, endDate, organizationId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlCars}/admin/${startDate}/${endDate}/${organizationId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getActiveUser() {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getBookingActiveUser() {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getSMSActivity(startDate, endDate) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlSmsHistory}/admin/${startDate}/${endDate}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/report.service.js